import React, { useState } from 'react';

const ROICalculator = () => {
  const [projectType, setProjectType] = useState('web');
  const [timeline, setTimeline] = useState(3);
  const [features, setFeatures] = useState(5);

  const basePrice = { web: 5000, mobile: 8000, enterprise: 15000 };
  const pricePerMonth = basePrice[projectType] / 3;
  const featureBoost = features * 500;
  const totalEstimate = pricePerMonth * timeline + featureBoost;
  const roi = (totalEstimate * 3).toFixed(0); // Estimated 3x ROI

  return (
    <section id="roi-calculator">
      <div className="section-header">
        <h2 className="section-title">ROI Calculator</h2>
        <p className="section-subtitle">Estimate your project cost and potential ROI</p>
      </div>
      <div className="calculator-container">
        <div className="calculator-glass fade-in">
          <div className="calculator-form">
            <div className="form-group">
              <label>Project Type</label>
              <select value={projectType} onChange={(e) => setProjectType(e.target.value)}>
                <option value="web">Web Application - $5K base</option>
                <option value="mobile">Mobile App - $8K base</option>
                <option value="enterprise">Enterprise Solution - $15K base</option>
              </select>
            </div>

            <div className="form-group">
              <label>Timeline: {timeline} months</label>
              <input 
                type="range" 
                min="1" 
                max="12" 
                value={timeline} 
                onChange={(e) => setTimeline(parseInt(e.target.value))}
              />
            </div>

            <div className="form-group">
              <label>Number of Features: {features}</label>
              <input 
                type="range" 
                min="1" 
                max="20" 
                value={features} 
                onChange={(e) => setFeatures(parseInt(e.target.value))}
              />
            </div>

            <div className="result-box">
              <div className="result-item">
                <span>Estimated Project Cost</span>
                <p className="result-value">${totalEstimate.toLocaleString()}</p>
              </div>
              <div className="result-item">
                <span>Estimated First Year ROI</span>
                <p className="result-value highlight">${roi}</p>
              </div>
              <div className="result-item">
                <span>ROI Ratio</span>
                <p className="result-value">3:1</p>
              </div>
            </div>

            <button className="glass-btn glass-btn-primary" style={{width: '100%', justifyContent: 'center'}}>
              <span>Get Detailed Quote</span> →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ROICalculator;
